export const environments = {
  unknown: "unknown",
  staging: "staging",
  production: "production",
  prodops: "prodops",
  test: "test",
  development: "development",
  cit: "cit",
  preview: "preview",
  circleCI: "circleCI",
  evals: "evals",
  qa: "qa",
  perf: "perf",
} as const;

export type Environments = (typeof environments)[keyof typeof environments];

type UnleashInstances =
  | "development"
  | "test"
  | "production"
  | "prodops"
  | "cit"
  | "circleCI"
  | "evals";

// Since these need to be exposed in the browser, we are explicitly not treating
// these as secrets
export const apiTokens: Readonly<Record<UnleashInstances, string>> = {
  circleCI: "default:development",
  development: "default:development.unleash-insecure-frontend-api-token",
  test: "*:development.06a736f77f07d37ad7c32dd4f53741cf373072e178e89f0fd408ea76",
  cit: "*:production.b659377f39107a20dbd99623739ffd3eb01d93f1eef0d1924f6888a5",
  production: "*:production.fa18c69baaf11109ff9e0f84f909cbeadd7d73bbe0d3e3ba4bbc5b38",
  prodops: "*:production.bbcc16a5e93b9d1ce8e04cd9679b1f4b56383a534c89607b2624d9a6",
  evals: "*:production.153aaceb7a7276e399eef5861669b3275443159cab9279f81373810d",
};

const frontendAPIPath = "/api/frontend";

export const apiUrls: Readonly<Record<UnleashInstances, string>> = {
  circleCI: `http://localhost:3063${frontendAPIPath}`,
  development: `http://localhost:4242${frontendAPIPath}`,
  test: `https://backend.test.junipersquare.us/flags${frontendAPIPath}`,
  cit: `https://backend.cit.junipersquare.com/flags${frontendAPIPath}`,
  production: `https://backend.junipersquare.com/flags${frontendAPIPath}`,
  prodops: `https://backend.prodops.junipersquare.com/flags${frontendAPIPath}`,
  evals: `https://backend.evals.junipersquare.com/flags${frontendAPIPath}`,
};
